import { createSlotRecipe } from './runtime.mjs';

const collapsibleConfig = {"name":"collapsible","className":"wd-collapsible","slots":["root","trigger","content"],"defaultVariants":{"size":"md","variant":"dark"},"variantMap":{"variant":["dark","light","ghost"],"size":["sm","md","lg"]}}

export const collapsible = /* @__PURE__ */ createSlotRecipe(collapsibleConfig)